import { render } from "./attachmentViewer.vue?vue&type=template&id=5256d152&scoped=true"
import script from "./attachmentViewer.vue?vue&type=script&lang=js"
export * from "./attachmentViewer.vue?vue&type=script&lang=js"

import "./attachmentViewer.vue?vue&type=style&index=0&id=5256d152&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5256d152"]])

export default __exports__